import { BsCarFrontFill, BsDiagram3, BsFillHouseFill, BsTag } from "react-icons/bs";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { IoSettingsOutline } from "react-icons/io5";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { MdOutlineBuild } from "react-icons/md";
import { MdOutlineSupportAgent, MdOutlinePeopleAlt } from "react-icons/md";
import { BsQuestionCircle } from "react-icons/bs";
import { BsClockHistory } from "react-icons/bs";
import { FaRegCalendarCheck, FaRegClock } from "react-icons/fa6";
import { MdOutlineEventBusy, MdOutlineChecklist, MdOutlineMyLocation } from "react-icons/md";
import { BsJournalCheck, BsCreditCard2Front } from "react-icons/bs";

export const sidebarMenu = [
    {
        title: "MAIN",
        items: [
            { name: "Dashboard", icon: <BsFillHouseFill />, path: "/dashboard", check: "dashboard" },
            { name: "My Attendance", icon: <BsClockHistory />, path: "/attendance", check: "attendance" },
        ],
    },
    {
        title: "TEAM",
        items: [
            { name: "Team Attendance", icon: <FaRegCalendarCheck />, path: "/team/attend", check: "attend" },
            { name: "Time Off", icon: <MdOutlineEventBusy />, path: "/team/time-off", check: "time-off" },
            { name: "Shift Allocation", icon: <FaRegClock />, path: "/team/shift", check: "team-shift" },
            { name: "Live Staff Map", icon: <MdOutlineMyLocation />, path: "/staff-tracking", check: "staff-tracking" },
        ],
    },
    {
        title: "OPERATIONS",
        items: [
            { name: "Bookings", icon: <BsJournalCheck />, path: "/booking", check: "booking" },
            { name: "Payments", icon: <BsCreditCard2Front />, path: "/payments", check: "payments" },
            { name: "Tasks", icon: <MdOutlineChecklist />, path: "/tasks", check: "tasks" },
        ],
    },
    {
        title: "CLIENTS",
        items: [
            { name: "Customers", icon: <MdOutlinePeopleAlt />, path: "/customers", check: "customers" },
            { name: "Associates", icon: <HiOutlineUserGroup />, path: "/associates", check: "associates" },
            { name: "Support Tickets", icon: <MdOutlineSupportAgent />, path: "/tickets", check: "tickets" },
            { name: "FAQ", icon: <BsQuestionCircle />, path: "/faq", check: "faq" },
        ],
    },
    // {
    //     title: "STAFF",
    //     items: [
    // { name: "Staff", icon: <HiOutlineUserGroup />, path: "/staff", check: "staff" },
    // { name: "Departments", icon: <MdOutlineAccountTree />, path: "/departments", check: "departments" },
    // { name: "Roles", icon: <MdOutlineAssignmentInd />, path: "/roles", check: "roles" },
    // { name: "Tasks", icon: <MdOutlineChecklist />, path: "/tasks", check: "tasks" },
    //     ],
    // },
    {
        title: "VEHICLES",
        items: [
            { name: "Brands", icon: <BsTag />, path: "/brand", check: "brand" },
            { name: "Models", icon: <BsCarFrontFill />, path: "/model", check: "model" },
            { name: "Variants", icon: <BsDiagram3 />, path: "/variant", check: "variant" },
            { name: "Cars", icon: <BsCarFrontFill />, path: "/car", check: "car" },
            { name: "Services", icon: <MdOutlineBuild />, path: "/vehicle-fleet/services", check: "services" },
        ],
    },

    {
        title: "MANAGEMENT",
        items: [
            // { name: "Hubs", icon: <HiOutlineOfficeBuilding />, path: "/hubs", check: "hubs" },
            { name: "Settings", icon: <IoSettingsOutline />, path: "/settings", check: "settings" },
        ],
    },
];
